export default import.meta.ROLLUP_FILE_URL_E_tdA4mxqOVmCC$G165SWQ